module.exports = __webpack_public_path__ + "img/right-arrow.940a1d92.svg";